import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BookCard, AuthorCard, GenreCard, TropeCard, EmptyState } from "@/components/cards";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [d, setD] = useState(null);
  useEffect(() => { if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setD(r.data)); }, [q]);
  if (!q) return <div className="py-24 text-center text-muted-foreground">Type something to search.</div>;
  if (!d) return <div className="py-24 text-center text-muted-foreground">Searching…</div>;
  const total = d.books.length + d.authors.length + d.genres.length + d.tropes.length;

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10 fade-in">
      <h1 className="text-3xl md:text-4xl font-display font-bold">Results for "<span className="text-primary">{q}</span>"</h1>
      <p className="text-sm text-muted-foreground mt-2">{total} results</p>
      {total === 0 && <div className="mt-10"><EmptyState title="No results found" subtitle="Try a different title, author or trope." /></div>}

      {d.books.length > 0 && (<section className="mt-10"><h2 className="text-xl font-display font-bold mb-4">Stories</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">{d.books.map((b) => <BookCard key={b.id} book={b} />)}</div></section>)}
      {d.authors.length > 0 && (<section className="mt-10"><h2 className="text-xl font-display font-bold mb-4">Authors</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">{d.authors.map((a) => <AuthorCard key={a.id} author={a} />)}</div></section>)}
      {d.genres.length > 0 && (<section className="mt-10"><h2 className="text-xl font-display font-bold mb-4">Genres</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">{d.genres.map((g) => <GenreCard key={g.id} genre={g} />)}</div></section>)}
      {d.tropes.length > 0 && (<section className="mt-10"><h2 className="text-xl font-display font-bold mb-4">Tropes</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">{d.tropes.map((t) => <TropeCard key={t.id} trope={t} />)}</div></section>)}
    </div>
  );
}
